<template>
    <SearchBar :placeholder="$t('modules.refs.topbar.searchLabel')" :hasResults="hasResults" @queryChange="setQuery">

        <!-- <div class="search_ref_item" v-for="ref in searchedRefs" >
            <router-link :to='"/refs/"+ref.id'>
                <span >{{ref.name}}</span>
            </router-link>
        </div> -->

    </SearchBar>
</template>

<script>
export default {
    name: 'TopbarSearchRef',
    components: {},
    data(){
        return {
            query: ""
        }
    },
    computed: {
        searchedRefs(){
            return this.$store.getters['RefStore/searchRefs'](this.query)
        },
        hasResults(){
            return this.searchedRefs.length > 0
        }
    },
    methods: {
        setQuery(query){
            this.query = query
            const data = {
                search_query: query,
                page: 1
            }
            this.$store.dispatch('RefStore/CustomRefsList', data)
        }
    }
}
</script>

<style lang="scss">
    .search_ref_item{
        border-top: 1px solid #ebebeb;
        a{
            padding: 18px 30px;
            display: block;
        }
        &:first-child{
            border-top: none;
        }
    }
</style>
